import { colors } from '../../config'

export default{
    computed:{
        primaryColor(){
            return colors.primary
        },
        secondaryColor(){
            return colors.secondary
        },
        accentColor(){
            return colors.accent
        },
        infoColor(){
            return colors.info
        },
        successColor(){
            return colors.success
        },
        warningColor(){
            return colors.warning
        },
        errorColor(){
            return colors.error
        },
        grey(){
            return '#f5f5f5'
        },
        errorWithActionColor(){
            return colors.errorWithActionColor
        }

    },
    methods:{
        color(name){
            switch(name){
                case 'info':
                    return this.infoColor
                    break;
                case 'success':
                    return this.successColor
                    break;
                case 'warning':
                    return this.warningColor
                    break;
                case 'error':
                    return this.errorColor
                    break;
                default: 
                    return '#f5f5f5';
            }
        },
        assetStatusColor(asset){
            let color = '#e91e63'
            
            if(asset.statusCode == "OK"){
                color = this.successColor
              }
              else if (asset.statusCode == "ACTION"){
                color = this.accentColor
              }
              else if(asset.statusCode == "ERROR_WITH_ACTION"){
                color = "#7d46ed"
              }
              else if(asset.statusCode == "ERROR"){
                color = this.errorColor
              }        

              // overwrite above is applicable
              if(asset.statusColor){
                color = asset.statusColor
              }

              return color
        }
    }
}